export type ExpenseDialogCloseIntent = "dismiss" | "confirmation";

export class ExpenseDialogFlow {
  private closeIntent: ExpenseDialogCloseIntent = "dismiss";

  beginConfirmation(): void {
    this.closeIntent = "confirmation";
  }

  consumeCloseIntent(): ExpenseDialogCloseIntent {
    const intent = this.closeIntent;
    this.closeIntent = "dismiss";
    return intent;
  }
}
